export interface ChartWeeksPurchaseOrders {
  orderDate: Date;
  numberOfOrders: number;
  quantity: number;
  value: number;
}
